<template>
  <v-container>

    <v-row><h1>Configure AlcoMeasure</h1></v-row>
    <v-row><p class="error" v-if="error">{{ error }}</p></v-row>
    <v-row>
      <v-snackbar v-model="updated" timeout=6000>
        Settings updated
        <template v-slot:action="{ attrs }">
          <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="updated = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-row>

    <div v-if="selectedBusinessId != ''">
      <v-card outlined>
        <v-card-title primary-title>
          Notification URL
        </v-card-title>
        <v-card-text>
          <v-btn icon color="primary" @click="copyToClipboard(notificationURL)">
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>
            {{ notificationURL }}
        </v-card-text>
      </v-card>

      <v-card outlined>
        <v-card-title primary-title>
          Notification Body
        </v-card-title>
        <v-card-text>
          <v-btn icon color="primary" @click="copyToClipboard(notificationString)">
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>
            {{ notificationString }}
        </v-card-text>
      </v-card>

      <v-card outlined>
        <v-card-title primary-title>
          Token
        </v-card-title>
        <v-card-text>
          <v-btn icon color="primary" @click="copyToClipboard(alcomeasureToken)">
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>
            {{ alcomeasureToken }}
        </v-card-text>
      </v-card>
    </div>

    <v-snackbar
      v-model="copiedSnackbar"
      timeout=1000
    >
      Copied to clipboard
      <template v-slot:action="{ attrs }">
        <v-btn icon color="blue" @click="copiedSnackbar = false" v-bind="attrs">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import BusinessService from '../services/BusinessService';
import UserService from '../services/UserService';

export default {
  name: 'AlcoMeasure',
  data() {
    return {
      business: {},
      error: '',
      updated: false,
      dialog: false,
      selectedBusinessId: '',
      user: {},
      userId: this.$auth.user.sub.split('|')[1],
      copiedSnackbar: false,
      alcomeasureToken: '',
      notificationString:
`{
"timestamp": "{{DTSecondsSinceEpochUTC}}",
"resultOverLimit": "{{ResultGreaterEqualBool}}",
"deviceSerial": "{{DeviceSerial}}",
"readingValue": {{Result}}
}`,
    };
  },
  async created() {
    const token = await this.$auth.getTokenSilently();
    this.user = await UserService.getUser(this.userId, token);
    const { businessIds } = this.user;
    if (businessIds.length > 0) {
      [this.selectedBusinessId] = businessIds;
      this.business = await BusinessService.getBusiness(this.selectedBusinessId, token);
      if (
        this.business
        && this.business.externalServiceKeys
        && this.business.externalServiceKeys.alcomeasure
      ) {
        this.alcomeasureToken = this.business.externalServiceKeys.alcomeasure;
      } else {
        const response = await BusinessService.getAlcomeasureToken(
          this.selectedBusinessId, token,
        );
        this.alcomeasureToken = response.data.token;
      }
    }
  },
  computed: {
    notificationURL() {
      return `https://timesync.paycat.com.au/api/v1/alcomeasure/${this.selectedBusinessId}/submit`;
    },
    receiverURL() {
      return `https://timesync.paycat.com.au/api/v1/alcomeasure/${this.selectedBusinessId}/check`;
    },
  },
  methods: {
    reportError(err) {
      this.error = err.message;
    },
    copyToClipboard(value) {
      window.navigator.clipboard.writeText(value);
      this.copiedSnackbar = true;
    },
  },

};
</script>

<style scoped>
div.container {
  /* max-width: 800px; */
  padding: 10px;
  margin: 0 auto;
}

p.error {
  border: 1px solid #ff5b5f;
  background-color: #ffc5c1;
  padding: 10px;
  margin-bottom: 15px;
}

</style>
